
const WebampIframe = ({ src }) => {
	return (
		<>
			<iframe src={src} name="" title="" style={{ width: 275, height: 350, border: 0 }}>
			</iframe>
		</>
	);
};
export default WebampIframe;